// Where a logged-out admin was trying to go, so login can take them back
// there instead of the dashboard. Email deep links (Dex nudges, ticket and
// notification links) depend on this.
//
// sessionStorage, not state: login navigates through /auth/crossing, which
// unmounts the guard that saw the original URL. Per tab, so a link opened in
// a new tab only ever returns that tab.

const KEY = 'deskos.returnTo';

// Only same-origin admin paths. Anything else (absolute URLs, //host, other
// sections) is refused so this can never become an open redirect.
const isSafeAdminPath = (path) =>
  typeof path === 'string' && path.startsWith('/admin/') && !path.startsWith('//') && !path.includes('://');

export const saveReturnTo = (path) => {
  if (!isSafeAdminPath(path) || path.startsWith('/admin/login')) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    // Storage blocked: login falls back to the default landing page.
  }
};

// Read once and clear, so a later plain login does not bounce back here.
export const consumeReturnTo = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafeAdminPath(path) ? path : null;
  } catch (e) {
    return null;
  }
};
